module.exports = __webpack_public_path__ + "img/hr-water1.92b03442.png";